import * as React from 'react';
import { FavoriteButton } from '../FavoriteButton/FavoriteButton';
import * as styles from './FavoriteButtonsGroup.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function FavoriteButtonsGroup(_ref) {
  var isFavorite = _ref.isFavorite,
    folderButton = _ref.folderButton,
    onClickFavorite = _ref.onClickFavorite;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [/*#__PURE__*/_jsx(FavoriteButton, {
      isFavorite: isFavorite,
      onClick: onClickFavorite
    }), /*#__PURE__*/_jsx("div", {
      children: folderButton
    })]
  });
}